import { ActionSurfaceHost, CommandPalette } from './components';
import { useControlCenter } from './useControlCenter';

export const ControlCenterOverlays = () => {
    const state = useControlCenter();

    return (
        <>
            <CommandPalette
                isOpen={state.isPaletteOpen}
                onClose={state.onClosePalette}
                onRun={state.onRunAction}
                isRefused={(id) => state.refusals.refusalFor(id) !== null}
                onTogglePin={state.onTogglePin}
                totalCount={state.totalCount}
            />
            <ActionSurfaceHost
                instanceId={state.surfaceInstanceId}
                onClose={state.onCloseAction}
                onDone={state.onActionDone}
                surface={state.openSurface}
            />
        </>
    );
};
